import { defineRecipe } from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
  base: {
    fontWeight: "bold",
    borderRadius: "4px",
    focusVisibleRing: "none",
    _focus: {
      outline: "none !important",
      boxShadow: "0 0 0 4px var(--chakra-colors-focus-500)",
      animation: "accessibility-outline-pulse 300ms ease-in-out !important",
    },
  },
  variants: {
    visual: {
      primary: {
        bg: "primary.800",
        color: "white",
        borderWidth: "2px",
        borderColor: "primary.600",
        boxSizing: "border-box",
        transition: "background-color 0.15s ease, border-color 0.15s ease",
        _hover: {
          bg: "primary.900",
          borderColor: "primary.600",
        },
        _active: {
          bg: "primary.1000",
          borderColor: "primary.1100",
        },
        _disabled: {
          borderColor: "primary.600",
        },
      },
      secondary: {
        bg: "primary.800",
        color: "white",
        transition: "background-color 0.15s ease",
        _hover: {
          bg: "primary.900",
        },
        _active: {
          bg: "primary.1000",
        },
      },
      secondaryLight: {
        bg: "primary.200",
        color: "textBlack.800",
        borderWidth: "2px",
        borderColor: "primary.700",
        boxSizing: "border-box",
        transition: "background-color 0.15s ease, border-color 0.15s ease",
        _hover: {
          bg: "primary.300",
          borderColor: "primary.900",
        },
        _active: {
          bg: "primary.500",
          borderColor: "primary.1200",
        },
      },
      dark: {
        minW: "85px",
        bgColor: "primary.900",
        borderWidth: "2px",
        borderColor: "black",
        color: "white",

        _hover: {
          bg: "primary.900",
          borderColor: "black",
        },
        _active: {
          bg: "primary.900",
          outlineColor: "pink.700",
          outlineWidth: "4px",
          outlineOffset: "2px",
          outlineStyle: "solid",
          transition: "outline 0.1s ease-in-out",
        },
      },

      outline: {
        bg: "white",
        color: "black",
        borderWidth: "2px",
        borderColor: "textBlack.400",
        boxSizing: "border-box",
        transition: "border-color 0.15s ease",
        _hover: {
          bg: "white",
          borderColor: "textBlack.700",
        },
        _active: {
          bg: "white",
          borderColor: "textBlack.800",
        },
      },
      outlineGreen: {
        bgColor: "white",
        color: "primary.600",
        borderWidth: "2px",
        borderColor: "primary.600",

        _hover: {
          bg: "white",
          borderColor: "primary.600",
        },
        _active: {
          bg: "primary.600",
          outlineColor: "pink.700",
          outlineWidth: "4px",
          outlineOffset: "2px",
          outlineStyle: "solid",
          transition: "outline 0.1s ease-in-out",
        },
      },

      green: {
        minW: "85px",
        bgColor: "primary.600",
        borderWidth: "2px",
        borderColor: "green.800",
        color: "white",

        _hover: {
          bg: "primary.600",
          borderColor: "green.800",
        },
        _active: {
          bg: "primary.600",
          outlineColor: "pink.700",
          outlineWidth: "4px",
          outlineOffset: "2px",
          outlineStyle: "solid",
          transition: "outline 0.1s ease-in-out",
        },
      },

      back: {
        bg: "transparent",
        color: "black",
        borderWidth: "0",
        transition: "background-color 0.15s ease",
        _hover: {
          bg: "textBlack.200",
        },
        _active: {
          bg: "textBlack.400",
        },
      },

      yesem: {
        bg: "yesem.500",
        color: "white",
        borderWidth: "2px",
        borderColor: "yesem.300",
        boxSizing: "border-box",
        transition: "background-color 0.15s ease",
        _hover: {
          bg: "yesem.700",
        },
        _active: {
          bg: "yesem.900",
        },
      },

      yesemDark: {
        bg: "yesem.500",
        color: "white",
        borderWidth: "2px",
        borderColor: "white",
        boxSizing: "border-box",
        transition: "background-color 0.15s ease",
        _hover: {
          bg: "yesem.700",
        },
        _active: {
          bg: "yesem.900",
        },
      },
    },
  },
});
